import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { catchError, map, Observable, of } from 'rxjs';

import { ReportsService } from '../../../core/services/reports.service';
import { LoadingService } from '../../../core/services/loading.service';
import { SubscriptionTypes } from '../../../core/models/subscription-types.model';

@Injectable({
  providedIn: 'root'
})
export class DiagnosticResolver  {
  constructor(
    private reportsService: ReportsService,
    private loadingService: LoadingService,
  ) {}

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    let schoolID = this.reportsService.getSelectedSchoolForReports().schoolID ;
    let isSystem = route.data['product'] === SubscriptionTypes.FullProduct ;

    // Diagnostic data needs at least a school selected
    if (schoolID === 0)
    {
      return of({
        erred: true,
        message: 'Please select a School',
      }) ;
    }

    this.loadingService.start() ;
    return this.reportsService.getDiagnosticData(isSystem).pipe(
      map((data) => {
        this.loadingService.finish() ;

        return data ;
      }),
      catchError((error) => {
        this.loadingService.finish() ;

        return of(error.status) ;
      })
    ) ;
  }
}
